module.exports = __webpack_public_path__ + "static/media/Empty-Data.d4e9b220.svg";